import { render, staticRenderFns } from "./BookUploaderListItem.vue?vue&type=template&id=53f0dbc1&scoped=true"
import script from "./BookUploaderListItem.vue?vue&type=script&lang=ts"
export * from "./BookUploaderListItem.vue?vue&type=script&lang=ts"
import style0 from "./BookUploaderListItem.vue?vue&type=style&index=0&id=53f0dbc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f0dbc1",
  null
  
)

export default component.exports